module.exports = __webpack_public_path__ + "img/Daytona Beach Hotel.72bbd522.png";